import gql from 'graphql-tag';

export const GET_OPERATION_ACCESSES_LIST = gql`
    query(
      $golf_group_code: String!
      $user_id: ID!
      $vue_id: String!
      $element_id: String
    ) {
      GetOperationAccessList(
        golf_group_code: $golf_group_code
        user_id: $user_id
        vue_id: $vue_id
        element_id: $element_id
    ) {
      OperationAccessList{
        user_div
        vue_id
        vue_name
        element_id
        element_name
        element_control
        display_control
      }
      ChatboxSetting
      PointSetting
      CardSetting
    }
  }
`;

export const GET_ALL_OPERATION_ACCESSES_LIST = gql`
    query(
      $golf_group_code: String
    ) {
    GetAllOperationAccessList(
        golf_group_code: $golf_group_code
    ) {
        AllOperationAccessList{
            vue_id
            system_user_div
            system_element_control
            golf_user_div
            golf_element_control
            vue_name
            element_id
            element_name
            element_control
            display_vue_name
      }
    }
  }
`;

export const UPDATE_OPERATION_ACCESSES = gql`
    mutation(
        $OperationAccessesList: [ChangeOperationAccessList]
    ){
        UpdateOperationAccesses(
            UpdateOperationAccessesList: $OperationAccessesList
        ){
            result
        }
    }
`;

export const GET_AUTHORITY_RELEASE_FLAG_LIST = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $user_id: ID!
    $vue_id: String!
    $element_id: String
    $plan_id: String!
    $year: String!
    $month: String!
  ) {
    GetAuthorityReleaseFlagList(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      user_id: $user_id
      vue_id: $vue_id
      element_id: $element_id
      plan_id: $plan_id
      year: $year
      month: $month
    ) {
      OperationAccessList{
        user_div
        vue_id
        vue_name
        element_id
        element_name
        element_control
        display_control
      }
      YearList{
        year
      }
      CoursesList{
        course_code
        course_name
      }
      getReleaseFlag{
        play_start
        course_code
        days{
            day1
            day2
            day3
            day4
            day5
            day6
            day7
            day8
            day9
            day10
            day11
            day12
            day13
            day14
            day15
            day16
            day17
            day18
            day19
            day20
            day21
            day22
            day23
            day24
            day25
            day26
            day27
            day28
            day29
            day30
            day31
        }
      }
    }
  }
`;
